'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { Button } from '@/components/common/button';
import { urlFor } from '@/sanity/lib/image';
import type { ALL_LOCATIONS_FOR_SEARCH_QUERY_RESULT } from '@/sanity/types';
import BookingDropdown from '../Location/BookingDropdown';
type LocationCardProps = {
  location: ALL_LOCATIONS_FOR_SEARCH_QUERY_RESULT[number];
};
export default function LocationCard(t0) {
  const $ = _c(40);
  const {
    location
  } = t0;
  const slug = location.slug;
  let t1;
  if ($[0] !== location.mainImage) {
    t1 = location.mainImage ? urlFor(location.mainImage).width(400).height(287).url() : null;
    $[0] = location.mainImage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageUrl = t1;
  const address = location.address;
  let t2;
  if ($[2] !== address) {
    t2 = address ? [address.streetAddress, address.streetAddress2, address.city, address.state, address.zipCode].filter(Boolean).join(", ") : "";
    $[2] = address;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const addressString = t2;
  const t3 = `/${slug}`;
  let t4;
  if ($[4] !== imageUrl || $[5] !== location.locationName) {
    t4 = <div className="relative h-[287px] w-full shrink-0 overflow-hidden rounded-[20px]">{imageUrl ? <Image src={imageUrl} alt={location.locationName || "Location"} fill={true} sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw" className="object-cover" /> : <div className="h-full w-full bg-gray-200" />}</div>;
    $[4] = imageUrl;
    $[5] = location.locationName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== location.locationName) {
    t5 = <h3 className="text-2xl font-bold text-primary-blue">{location.locationName}</h3>;
    $[7] = location.locationName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== addressString) {
    t6 = addressString && <p className="text-lg leading-[26px] text-primary-blue">{addressString}</p>;
    $[9] = addressString;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="flex flex-col gap-1.5">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t7) {
    t8 = <Link href={t3} className="flex flex-col gap-[19px]">{t4}{t7}</Link>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== address) {
    t9 = (address?.phone || address?.email) && <div className="flex flex-col gap-0 text-lg leading-[26px] text-primary-blue"><p className="flex flex-wrap gap-3">{address.phone && <a href={`tel:${address.phone}`} className="underline">{address.phone}</a>}{address.email && <a href={`mailto:${address.email}`} className="underline">Email us</a>}</p></div>;
    $[18] = address;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== slug) {
    t10 = slug && <Button asChild={true} variant="inverse" className="font-bold"><Link href={`/${slug}`}>Explore location</Link></Button>;
    $[20] = slug;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== slug) {
    t11 = slug && <Button asChild={true} variant="inverse" className="flex-1 font-bold"><Link href={`/${slug}#fees`}>Review fees</Link></Button>;
    $[22] = slug;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  const t12 = location.tourBooking?.tourBookingUrl;
  const t13 = location.admissionsPartner?.callBookingUrl;
  let t14;
  if ($[24] !== location.locationName || $[25] !== t12 || $[26] !== t13) {
    t14 = <BookingDropdown tourBookingUrl={t12} callBookingUrl={t13} className="flex-1 font-bold" locationName={location.locationName} />;
    $[24] = location.locationName;
    $[25] = t12;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t11 || $[29] !== t14) {
    t15 = <div className="flex gap-2.5">{t11}{t14}</div>;
    $[28] = t11;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t15) {
    t16 = <div className="flex flex-col gap-2.5">{t10}{t15}</div>;
    $[31] = t10;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t16 || $[35] !== t9) {
    t17 = <div className="mt-auto flex flex-col gap-5">{t9}{t16}</div>;
    $[34] = t16;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t17 || $[38] !== t8) {
    t18 = <article className="flex h-full flex-col gap-1.5">{t8}{t17}</article>;
    $[37] = t17;
    $[38] = t8;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
}